module.exports = __webpack_public_path__ + "static/media/popup-warning.fc885a16.svg";